import type { Application, Offer, UnitClass } from '../../data/types';
import { applicationPayment } from '../../domain/raise/raiseCalc';

const IN_PROGRESS = new Set(['INVITED', 'IN_PROGRESS']);
const CLOSED = new Set(['REJECTED', 'WITHDRAWN']);

export interface OfferTotals {
  applications: number;
  inProgress: number;
  amlReferred: number;
  notPaid: number;
  paid: number;
  totalInitial: number;
  payableLater: number;
  total: number;
}

export const MONEY_TOTALS = new Set<keyof OfferTotals>([
  'notPaid',
  'paid',
  'totalInitial',
  'payableLater',
  'total',
]);

export function offerApplications(offer: Offer, applications: Application[]) {
  return applications.filter(
    (application) => application.classId === offer.classId && !CLOSED.has(application.status),
  );
}

export function offerTotals(
  offer: Offer,
  applications: Application[],
  unitClass?: UnitClass,
): OfferTotals {
  const rows = offerApplications(offer, applications);
  const totals: OfferTotals = {
    applications: rows.length,
    inProgress: rows.filter((application) => IN_PROGRESS.has(application.status)).length,
    amlReferred: rows.filter((application) => application.status === 'KYC_REVIEW').length,
    notPaid: 0,
    paid: 0,
    totalInitial: 0,
    payableLater: 0,
    total: 0,
  };
  for (const application of rows) {
    if (IN_PROGRESS.has(application.status)) continue;
    const payment = applicationPayment(application, unitClass);
    totals.notPaid += payment.outstanding;
    totals.paid += payment.received;
    totals.totalInitial += payment.payableNow;
    totals.payableLater += payment.payableLater;
    totals.total += application.amount;
  }
  return totals;
}
